import { Component, Vue } from 'vue-property-decorator';
import { RewardItemDTO, RewardRequestDTO } from '@/models';
import { REWARD_REQUEST_STATUSES } from '@/constants';

@Component
export default class RewardPeriodDetailOverall extends Vue {
  get rewardItems(): RewardItemDTO[] {
    return this.$store.getters['rewardPeriod/rewardItems'];
  }

  get rewardRequests(): RewardRequestDTO[] {
    return this.$store.getters['rewardPeriod/rewardRequests'];
  }

  get requestItems(): number {
    return this.getApprovedRequests().length;
  }

  get dropsSpent(): number {
    return this.getApprovedRequests().reduce((drops, request) => drops + request.rewardItem.cost, 0);
  }

  get estimatedFundSpent(): number {
    return this.getApprovedRequests().reduce((drops, request) => drops + request.rewardItem.estimatedPrice, 0);
  }

  get actualFundSpent(): number {
    return this.getApprovedRequests().reduce((drops, request) => drops + (request.actualPrice ?? 0), 0);
  }

  get totalItems(): number {
    return this.rewardItems.reduce((nItems, item) => nItems + item.quantity, 0);
  }

  get totalDrops(): number {
    return this.rewardItems.reduce((drops, item) => drops + item.cost * item.quantity, 0);
  }

  get totalFund(): number {
    return this.rewardItems.reduce((drops, item) => drops + item.estimatedPrice * item.quantity, 0);
  }

  getApprovedRequests(): RewardRequestDTO[] {
    return this.rewardRequests.filter(request => request.status === REWARD_REQUEST_STATUSES.APPROVED.label);
  }
}
